import {Guid, IEntity, Metadata} from '@app/views/databrowsing/model/common.data.models';
import {PagedDataItem} from '@app/views/databrowsing/model/paged-data';

export class LinkedEntities {
    [entity: string]: LinkedEntityItem[];

    static getLinks<T>(links: LinkedEntityItem[],
        linkData: T[],
        getLink: (T) => LinkedEntityItem,
        getLinkDataGuid: (T) => string
    ): LinkedEntityItem[] {
        if (!links || (links && (links.length === 1) && (links[0] === null))) {
            links = [];
        }
        links = links.filter(link => !!link);

        let result = [];
        if (linkData && linkData.length > 0) {
            if (linkData.length !== links.length) {
                const map = new Map();
                for (const item of links.concat(linkData.map((link: T) => getLink(link)))) {
                    if (item && !map.has(item.guid)) {
                        map.set(item.guid, true);
                        result.push(item);
                    }
                }
            } else {
                result = links.map((link: LinkedEntityItem) => {
                    if (!link.name || !link.guid) {
                        const linkDataItem = linkData.find((item: T) => getLinkDataGuid(item) === link.guid);
                        if (linkDataItem) {
                            const linkFromData = getLink(linkDataItem);
                            if (!link.name && linkFromData.name) {
                                link.name = linkFromData.name;
                            }
                            if (!link.guid && linkFromData.guid) {
                                link.guid = linkFromData.guid;
                            }
                        }
                    }
                    return link;
                });
            }
        } else {
            result = links;
        }

        return result;
    }

    static getEntityLink(data: PagedDataItem<IEntity>,
        linkedEntityAttrName: string,
        dataGuidAttrName: string = '',
        dataTitleAttrName: string = '') {
        if (data.linkedEntities[linkedEntityAttrName] && data.linkedEntities[linkedEntityAttrName].length > 0) {
            return data.linkedEntities[linkedEntityAttrName][0];
        } else {
            const guid = Guid.getValue(data.data[dataGuidAttrName]);
            if (guid) {
                return <LinkedEntityItem>{
                    guid: guid,
                    name: dataTitleAttrName ? data.data[dataTitleAttrName] : guid
                };
            } else {
                return null;
            }
        }
    }
}

export class LinkedEntityItem {
    guid: string;
    name: string;
    type: string;
    metadata?: Metadata[];
    _originalIndex?: number;
}

export class Link extends LinkedEntityItem {
    org: string;
    profilePhotoUrl: string;
}
